export default {"src":"/_next/static/media/noise.bf2b0ff9.svg","height":754,"width":1512};